import { ArrowRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useLang } from "@/context/LanguageContext";
import { Reveal, Overline } from "@/components/Reveal";

const IMAGES = {
  kids: "https://images.unsplash.com/photo-1503454537195-1dcabb73ffb9?auto=format&fit=crop&w=1600&q=80",
  jovenes: "https://images.unsplash.com/photo-1511632765486-a01980e01a18?auto=format&fit=crop&w=1600&q=80",
  familias: "https://images.unsplash.com/photo-1511895426328-dc8714191300?auto=format&fit=crop&w=1600&q=80",
  adoracion: "https://images.unsplash.com/photo-1470229722913-7c0e2dbbafd3?auto=format&fit=crop&w=1600&q=80",
  conexion: "https://images.unsplash.com/photo-1521017432531-fbd92d768814?auto=format&fit=crop&w=1600&q=80",
};

export default function Ministerios() {
  const { t } = useLang();
  const navigate = useNavigate();

  return (
    <div data-testid="ministerios-page">
      <section className="pt-40 pb-20 max-w-7xl mx-auto px-6 md:px-10">
        <Reveal>
          <Overline>{t.ministerios.overline}</Overline>
          <h1 className="font-display text-5xl md:text-7xl font-light tracking-tight mt-6 max-w-3xl">
            {t.ministerios.title}
          </h1>
          <p className="text-white/60 text-lg mt-8 max-w-xl leading-relaxed">{t.ministerios.sub}</p>
        </Reveal>
      </section>

      <section className="max-w-7xl mx-auto px-6 md:px-10 pb-24 md:pb-32 flex flex-col gap-24">
        {t.ministerios.items.map((m, i) => (
          <Reveal key={m.key}>
            <div
              className={`grid grid-cols-1 md:grid-cols-12 gap-10 items-center ${
                i % 2 === 1 ? "md:[direction:rtl]" : ""
              }`}
              data-testid={`ministry-${m.key}`}
            >
              <div className="md:col-span-6 [direction:ltr]">
                <div className="overflow-hidden border border-white/10">
                  <img
                    src={IMAGES[m.key]}
                    alt={m.title}
                    className="w-full aspect-[4/3] object-cover hover:scale-105 transition-transform duration-700"
                  />
                </div>
              </div>
              <div className="md:col-span-6 [direction:ltr]">
                <span className="font-display text-5xl font-light text-ember/70">
                  {String(i + 1).padStart(2, "0")}
                </span>
                <h2 className="font-display text-4xl md:text-5xl font-light mt-4 mb-4">{m.title}</h2>
                <div className="flex flex-wrap gap-3 mb-6">
                  <span className="text-xs uppercase tracking-[0.2em] border border-white/20 rounded-full px-4 py-1.5 text-white/60">
                    {m.age}
                  </span>
                  <span className="text-xs uppercase tracking-[0.2em] border border-ember/40 rounded-full px-4 py-1.5 text-sand">
                    {m.schedule}
                  </span>
                </div>
                <p className="text-white/60 leading-relaxed max-w-lg">{m.text}</p>
              </div>
            </div>
          </Reveal>
        ))}
      </section>

      <section className="border-t border-white/10 bg-coal">
        <div className="max-w-7xl mx-auto px-6 md:px-10 py-20 text-center">
          <Reveal>
            <button
              data-testid="volunteer-cta-btn"
              onClick={() => navigate("/contacto")}
              className="group inline-flex items-center gap-3 bg-ember text-white text-xs uppercase tracking-[0.2em] rounded-full px-10 py-5 hover:bg-sand hover:text-ink transition-colors duration-300"
            >
              {t.ministerios.cta}
              <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>
      </section>
    </div>
  );
}
